module.exports = __webpack_public_path__ + "static/media/checklist-summary.b31754b7.svg";